import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

export const BUSINESS_TIME_ZONE = 'America/Sao_Paulo';

const TIME_ZONE_SUFFIX_PATTERN = /(Z|[+-]\d{2}:\d{2})$/i;

const toValidDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatApiDateTime = (value) => {
  const date = toValidDate(value);
  if (!date) return value || '';

  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: BUSINESS_TIME_ZONE,
  }).format(date);
};

export const formatApiDate = (value) => {
  const date = toValidDate(value);
  if (!date) return value || '';

  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeZone: BUSINESS_TIME_ZONE,
  }).format(date);
};

export const formatDateOnly = (value) => {
  const raw = String(value || '').trim();
  const matchedDate = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (matchedDate) {
    return `${matchedDate[3]}/${matchedDate[2]}/${matchedDate[1]}`;
  }

  return raw;
};

export const toDateTimeLocalInputValue = (value) => {
  const date = toValidDate(value);
  if (!date) return '';

  return formatInTimeZone(date, BUSINESS_TIME_ZONE, "yyyy-MM-dd'T'HH:mm");
};

export const toBusinessDateInput = (value) => {
  const date = toValidDate(value);
  if (!date) return '';

  return formatInTimeZone(date, BUSINESS_TIME_ZONE, 'yyyy-MM-dd');
};

export const dateTimeLocalToUtcIso = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const date = TIME_ZONE_SUFFIX_PATTERN.test(raw)
    ? new Date(raw)
    : fromZonedTime(raw, BUSINESS_TIME_ZONE);

  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
};
